import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OutlookCalenderRoutingModule } from './outlook-calender-routing.module';
import { OutlookCalenderComponent } from './outlook-calender.component';
import { MsalModule, MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


let msalInstance: IPublicClientApplication | undefined = undefined;

export function MSALInstanceFactory(): IPublicClientApplication {
  msalInstance =
    msalInstance ??
    new PublicClientApplication({
      auth: {
        clientId: OAuthSettings.appId,
        redirectUri: OAuthSettings.redirectUri,
        postLogoutRedirectUri: OAuthSettings.redirectUri,
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
      },
    });

  return msalInstance;
}

@NgModule({
  declarations: [
    OutlookCalenderComponent
  ],
  imports: [
    CommonModule,
    OutlookCalenderRoutingModule,
    MsalModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule
    

  ],
   providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    MsalService,
  ],
  exports:[
    OutlookCalenderComponent
  ]
})
export class OutlookCalenderModule { }

export const OAuthSettings = {
  
  appId: 'da42efb8-7f62-4af5-8000-70c85f186c72',
  redirectUri: window.location.origin,
  scopes: ['user.read', 'mailboxsettings.read', 'calendars.readwrite'],
};
